import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

export const financialItemStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    paper: {
      // padding: "3em",
      // textAlign: "center",
      // color: theme.palette.text.secondary,
      // width: "100%",
      // overflowX: "auto"
      //  width:"30em"
      marginTop: "2em",
      padding: theme.spacing(2),
      textAlign: "center",
      color: theme.palette.text.secondary,
    },

    // tableLeftHead :{
    //   background : "white",
    //     textAlign :"left",
    //    // align:"left",
    //     //fontWeight:100,
    //     color:"#a20f0f"
    // },
    // tableRightHead :{
    //   background : "white",
    //     textAlign :"right",
    //    // align:"center",
    //     //fontWeight:100,
    //     color:"#a20f0f"
    // },
    // tableLeftContent :{
    //   background : "white",
    //     textAlign :"left",
    //   //  align:"left"
    // },
    // tableRightContent :{
    //   background : "white",
    //     textAlign :"right",
    //    // align:"center",

    // },
    //     tablecontent :{
    //       background : "white",
    //       textAlign :"center",
    //      //align:"center"
    //   },
    //   tableBody:{
    //     background :"white",
    //     textAlign:"left"
    //   },
    //   tablecontentHead :{
    //     background : "white",
    //     textAlign :"center",
    //    // align:"l",
    //     //fontWeight:100,
    //    // color:"#a20f0f"
    // },
    titlegap: {
      paddingTop: "2em",
    },
    titlecolor: {
      color: "#000",
      background: "antiquewhite",
    },
    printLeftDetail: {
      textAlign: "left",
      paddingRight: "1em",
      fontWeight: "bold",
      color: "#000",
    },
    printRightDetail: {
      textAlign: "right",
      paddingRight: "1em",
      fontWeight: "bold",
      color: "#000",
    },
    description: {
      paddingLeft: "2em",
      textAlign: "left",
      color: "#000",
    },
    reportTable: {
      minWidth: 450,
    },
    tableRoot: {
      width: "100%",
      overflowX: "auto",
    },

    total: {
      textAlign: "left",
      // paddingLeft: "1em",
      fontWeight: "bold",
      // paddingTop: "1em",
      color: "#000",
    },
    value: {
      textAlign: "right",
      // paddingRight: "1em",
      fontWeight: "bold",
      // paddingTop: "1em",
      color: "#000",
    },
    desptnWeight: {
      textAlign: "left",
      fontWeight: "bold",
      paddingLeft: "2em",
      color: "#000",
    },
    mart: {
      fontSize: "xx-large",
      textAlign: "left",
      paddingLeft: "1em",
      fontWeight: "bold",
      color: "#000",
    },
    report: {
      fontSize: "x-large",
      textAlign: "left",
      paddingLeft: "1em",
      fontWeight: "bold",
      color: "#000",
    },

    tableRow: {
      background: "white",
      color: "#a20f0f",
    },
    table: {
      minWidth: 650,
    },

    tableColumn: {
      textAlign: "center",
      fontWeight: 500,
      border: "1px solid gray",
      // paddingLeft: "2em"
    },
    tableContent: {
      fontWeight: 500,
      // paddingLeft: "1em",
      border: "1px solid gray",
    },
    foreignHead: {
      color: "#800000",
      fontWeight: 500,
      // paddingRight:"1em",
      border: "1px solid gray",
    },
    voidReturnHead: {
      // paddingRight:"4em",
      fontWeight: 500,
      color: "#800000",
      border: "1px solid gray",
    },
    deptHead: {
      color: "#800000",
      fontWeight: 500,
      // paddingRight:"2.25em",
      border: "1px solid gray",
    },
    headColor: {
      color: "#800000",
      fontWeight: 500,
      border: "1px solid gray",
    },
    tablegap: {
      marginTop: "1.5em",
    },
    columnWeight: {
      fontWeight: 500,
      border: "1px solid gray",
    },
    tablecontentSalesandCard: {
      color: "#800000",
      textAlign: "center",
      fontWeight: 500,
      border: "1px solid gray",
    },
    totalCellStyle: {
      borderLeft: "1px solid gray",
      borderBottom: "1px solid gray",
    },
    middleTotalcell: {
      borderBottom: "1px solid gray",
    },
    totalValueCell: {
      borderRight: "1px solid gray",
      borderBottom: "1px solid gray",
    },
  })
);
